/**
 * SWIXXZ ZMAGAZINE — retro scroll reveal + progress + dial-up status
 */
(function () {
  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  /* Mobile/touch: skip scroll-triggered CRT/parallax — they flash/jank like a refresh */
  function isTouchLayout() {
    return (
      window.matchMedia('(hover: none) and (pointer: coarse)').matches ||
      window.matchMedia('(max-width: 749px)').matches
    );
  }

  function bootStatus() {
    var el = document.querySelector('[data-zm-status]');
    if (!el) return;
    var lines = ['CONNECTING...', 'HANDSHAKE OK', 'LOADING ZINE...', 'ONLINE'];
    var i = 0;
    function next() {
      el.textContent = lines[i];
      if (lines[i] === 'ONLINE') {
        el.classList.add('is-online');
        return;
      }
      i += 1;
      window.setTimeout(next, prefersReducedMotion() ? 0 : 420);
    }
    next();
  }

  function revealOnScroll(selector) {
    var nodes = document.querySelectorAll(selector);
    if (!nodes.length) return;

    if (prefersReducedMotion() || !('IntersectionObserver' in window)) {
      nodes.forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -4% 0px' }
    );

    nodes.forEach(function (el) {
      io.observe(el);
    });
  }

  function bindProgress() {
    var bar = document.querySelector('[data-zm-progress]');
    var root = document.querySelector('[data-zm-issue]');
    if (!bar || !root) return;

    var ticking = false;
    function update() {
      ticking = false;
      var rect = root.getBoundingClientRect();
      var total = root.offsetHeight - window.innerHeight;
      var scrolled = Math.min(Math.max(-rect.top, 0), Math.max(total, 1));
      var pct = total > 0 ? (scrolled / total) * 100 : 0;
      bar.style.width = pct + '%';
    }

    function onScroll() {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(update);
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  }

  function preloadMagazinePages() {
    document.querySelectorAll('.zm-page img').forEach(function (img) {
      img.loading = 'eager';
      img.setAttribute('decoding', 'async');
      if (img.dataset.zmPreloaded === '1') return;
      img.dataset.zmPreloaded = '1';
      var warm = new Image();
      warm.decoding = 'async';
      warm.src = img.currentSrc || img.src;
    });
  }

  function fmtTime(s) {
    if (!isFinite(s) || s < 0) return '0:00';
    var m = Math.floor(s / 60);
    var r = Math.floor(s % 60);
    return m + ':' + (r < 10 ? '0' : '') + r;
  }

  function bindPlayers() {
    document.querySelectorAll('[data-zm-player]').forEach(function (root) {
      if (root.dataset.zmBound === '1') return;
      root.dataset.zmBound = '1';

      var video = root.querySelector('.zm-player__video');
      var big = root.querySelector('[data-zm-play]');
      var toggle = root.querySelector('[data-zm-toggle]');
      var mute = root.querySelector('[data-zm-mute]');
      var seek = root.querySelector('[data-zm-seek]');
      var time = root.querySelector('[data-zm-time]');
      if (!video) return;

      root.classList.add('is-paused');

      function setPlaying(playing) {
        root.classList.toggle('is-playing', playing);
        root.classList.toggle('is-paused', !playing);
        if (toggle) toggle.textContent = playing ? '❚❚' : '▶';
      }

      function play() {
        var p = video.play();
        if (p && typeof p.catch === 'function') p.catch(function () {});
      }

      function pause() {
        video.pause();
      }

      function updateTime() {
        if (!time || !seek) return;
        var cur = video.currentTime || 0;
        var dur = video.duration || 0;
        time.textContent = fmtTime(cur) + ' / ' + fmtTime(dur);
        if (!root.classList.contains('is-scrubbing') && dur > 0) {
          seek.value = String(Math.round((cur / dur) * 1000));
        }
      }

      if (big) {
        big.addEventListener('click', function () {
          play();
        });
      }

      if (toggle) {
        toggle.addEventListener('click', function () {
          if (video.paused) play();
          else pause();
        });
      }

      if (mute) {
        mute.addEventListener('click', function () {
          video.muted = !video.muted;
          mute.textContent = video.muted ? '✕♪' : '♪';
        });
      }

      if (seek) {
        seek.addEventListener('pointerdown', function () {
          root.classList.add('is-scrubbing');
        });
        seek.addEventListener('pointerup', function () {
          root.classList.remove('is-scrubbing');
        });
        seek.addEventListener('input', function () {
          if (!video.duration) return;
          video.currentTime = (Number(seek.value) / 1000) * video.duration;
          updateTime();
        });
      }

      root.addEventListener('click', function (e) {
        if (e.target.closest('.zm-player__bar') || e.target.closest('[data-zm-play]')) return;
        if (video.paused) play();
        else pause();
      });

      video.addEventListener('play', function () {
        setPlaying(true);
      });
      video.addEventListener('pause', function () {
        setPlaying(false);
      });
      video.addEventListener('timeupdate', updateTime);
      video.addEventListener('loadedmetadata', updateTime);
      video.addEventListener('ended', function () {
        setPlaying(false);
        video.currentTime = 0;
        updateTime();
      });
    });
  }

  function bindCountdowns() {
    document.querySelectorAll('[data-zm-countdown]').forEach(function (box) {
      if (box.dataset.zmBound === '1') return;
      box.dataset.zmBound = '1';
      var end = new Date(box.getAttribute('data-zm-countdown')).getTime();
      if (!end) return;
      var dEl = box.querySelector('[data-d]');
      var hEl = box.querySelector('[data-h]');
      var mEl = box.querySelector('[data-m]');
      var sEl = box.querySelector('[data-s]');
      if (!dEl || !hEl || !mEl || !sEl) return;
      function pad(n) {
        return n < 10 ? '0' + n : String(n);
      }
      function tick() {
        var left = end - Date.now();
        if (left <= 0) {
          box.classList.add('is-live');
          if (!box.querySelector('.zm-drop-clock__live')) {
            var live = document.createElement('div');
            live.className = 'zm-drop-clock__live';
            live.textContent = "IT'S LIVE";
            box.querySelector('.zm-drop-clock__ticket').appendChild(live);
          }
          return false;
        }
        var s = Math.floor(left / 1000);
        dEl.textContent = pad(Math.floor(s / 86400));
        hEl.textContent = pad(Math.floor(s / 3600) % 24);
        mEl.textContent = pad(Math.floor(s / 60) % 60);
        sEl.textContent = pad(s % 60);
        return true;
      }
      if (tick()) {
        window.setInterval(tick, 1000);
      }
    });
  }

  function init() {
    if (document.documentElement.dataset.zmInit === '1') {
      bindPlayers();
      bindCountdowns();
      return;
    }
    document.documentElement.dataset.zmInit = '1';

    bootStatus();
    /* Magazine pages + hub cards load fully visible — no scroll reveal */
    document.querySelectorAll('.zm-page, .zmagazine-issue-card, .zmagazine-card').forEach(function (el) {
      el.classList.add('is-visible');
    });
    preloadMagazinePages();
    bindProgress();
    bindPlayers();
    bindCountdowns();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
